export const PasedPackageFormData = [
  {
    fieldLabel: 'Interested in booking?',
    fieldPlaceHolder: '',
    fieldValue: '',
    fieldType: 7,
    orderPosition: 0,
    required: true,
  },
  {
    fieldLabel: 'Full Name',
    fieldPlaceHolder: 'Full Name',
    fieldValue: '',
    fieldType: 1,
    orderPosition: 2,
    required: true,
  },
  {
    fieldLabel: 'Email',
    fieldPlaceHolder: 'Email',
    fieldValue: '',
    fieldType: 5,
    orderPosition: 3,
    required: true,
  },
  {
    fieldLabel: 'Phone',
    fieldPlaceHolder: 'Phone',
    fieldValue: '',
    fieldType: 4,
    orderPosition: 4,
    required: true,
  },
  {
    fieldLabel: 'Message',
    fieldPlaceHolder: '',
    fieldValue: '',
    fieldType: 2,
    orderPosition: 5,
    required: false,
  },
]
